import React from 'react';

import { CardDetails } from '@/components/card/card-details/CardDetails';
import CardInfoWithFunctionalityContainer from '@/components/card/card-info-with-functionality/CardInfoWithFunctionalityContainer';
import { DigitalWallet } from '@/domain/digital-wallet';

export const TeCardDetails = () => (
    <div className="sgw-layout seven-four-container">
        <div className="sgw-layout-item seven">
            <div className="sgw-layout-item">
                <CardInfoWithFunctionalityContainer />
            </div>
            <div className="sgw-layout-item">
                <DigitalWallet />
            </div>
            <div className="sgw-layout-item only-for-desktop">
                <CardDetails />
            </div>
        </div>
    </div>
);
